import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_ClientReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NBT_ClientReport' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className="w-375" >
                            <span className="eleHeader">Program:</span>
                            <input type="text" id="txtAdmissionDate" name="txtAdmissionDate" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Frequency:</span>
                            <input type="radio" id="rbSessionFrequency_Bi" name="rbSessionFrequency" className="add-only" value="Bi-weekly" /> Bi-Weekly
                            &nbsp;
                            <input type="radio" id="rbSessionFrequency_Monthly" name="rbSessionFrequency" className="add-only" value="Monthly" /> Monthly
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader">Date:</span>
                            <input type="date" id="txtDate" name="txtDate" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader">Number of Sessions Attended:</span>
                            <input type="text" id="txtSessionsAttended" name="txtSessionsAttended" className="add-only" />
                        </td>
                    </tr>
                </table>
                <tr>
                    <td className="w-750">
                        <span className="eleHeader">Risk Factors:</span>
                        <textarea id="txtRiskFactors" name="txtRiskFactors" className="add-only"  ></textarea>
                    </td>
                </tr>
                <tr>
                    <td className="w-750">
                        <span className="eleHeader w-750;">Check all that apply as to the client’s involvement in the program:</span>
                    </td>
                </tr>
                <tr>
                    <td className="w=375">
                        <input type="checkbox" id="cbProgramInvolvement_1" name="cbProgramInvolvement_1" className="add-only" value="1" />
                        Terminated or refused continuation in the program
                    </td>
                </tr>
                <tr>
                    <td className="w=375"><input type="checkbox" id="cbProgramInvolvement_2" name="cbProgramInvolvement_2" className="add-only" value="2" />
                        Failure to report to group on time
                    </td>
                </tr>
                <tr>
                    <td className="w=375"> <input type="checkbox" id="cbProgramInvolvement_3" name="cbProgramInvolvement_3" className="add-only" value="3" />
                        Needs referral to different service or Additional Service
                    </td>
                </tr>

                <p className="w-750">
                    <span className="eleHeader">If "Terminated or refused continuation in the program", provide reason:</span>
                    <textarea id="txtReasonDenied" name="txtReasonDenied" className="add-only"  ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-600"><span className="eleHeader">Rate client on the following as to the degree of response
                            during intervention</span></td>
                        <td className="w-150"><span className="eleHeader">Comments</span></td>
                    </tr>
                    <tr>
                        <td className="w-450">Positive interaction with other group members/peers/parents</td>
                        <td className="w-150">
                            <select id="ddlResponse_1" name="ddlResponse_1" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_1" name="txtResponse_1" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Impulsive or disruptive behavior during program session</td>
                        <td className="w-150">
                            <select id="ddlResponse_2" name="ddlResponse_2" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_2" name="txtResponse_2" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Client attendance</td>
                        <td className="w-150">
                            <select id="ddlResponse_3" name="ddlResponse_3" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_3" name="txtResponse_3" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Response to facilitators or mentors</td>
                        <td className="w-150">
                            <select id="ddlResponse_4" name="ddlResponse_4" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_4" name="txtResponse_4" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Level of cooperation with program</td>
                        <td className="w-150">
                            <select id="ddlResponse_5" name="ddlResponse_5" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_5" name="txtResponse_5" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Follow through with homework/reading/assignments</td>
                        <td className="w-150">
                            <select id="ddlResponse_6" name="ddlResponse_6" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_6" name="txtResponse_6" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Participation in group discussion and individual activities</td>
                        <td className="w-150">
                            <select id="ddlResponse_7" name="ddlResponse_7" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_7" name="txtResponse_7" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Client understands behavior/ risks that they are working to improve</td>
                        <td className="w-150">
                            <select id="ddlResponse_8" name="ddlResponse_8" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_8" name="txtResponse_8" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Degree to which client understands ideas and concepts</td>
                        <td className="w-150">
                            <select id="ddlResponse_9" name="ddlResponse_9" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_9" name="txtResponse_9" className="add-only" /></td>
                    </tr>
                    <tr>
                        <td className="w-450">Expectation that client will achieve improved outcomes</td>
                        <td className="w-150">
                            <select id="ddlResponse_10" name="ddlResponse_10" className="add-only">
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Low Degree">Low Degree</option>
                                <option value="Moderate Degree">Moderate Degree</option>
                                <option value="High Degree">High Degree</option>
                            </select>
                        </td>
                        <td className="w-150"><input type="text" id="txtResponse_10" name="txtResponse_10" className="add-only" /></td>
                    </tr>
                </table>
                <p className="w-750">
                    <span className="eleHeader">Summary:</span>
                    <textarea id="txtSummary" name="txtSummary" className="add-only"  ></textarea>
                </p>
            </div>
        </form>
    )
}